<template>
  <v-container fluid grid-list-lg>
    <Create :createDialog="createDialog" @close="createDialog = false" @submit="getList" :donor="DonorId"></Create>
    <Edit v-if="editDialog" :editDialog="editDialog" @close="editDialog = false" @submit="getList"
      :editObj="selectedDonor"></Edit>
    <v-card :loading="loading" outlined>
      <ListTitle :showBackButton="showBackButton" :access="access" @add="add" title="Payment Request" />

      <v-card-title>
        <v-flex xs12 sm4>
          <v-text-field v-model="search" outlined prepend-inner-icon="search" rounded dense label="Search" single-line
            hide-details clearable></v-text-field>
        </v-flex>
      </v-card-title>
      <v-card-text>
        <v-data-table :headers="headers" :items="paymentReq" :search="search" :loading="loading" :sort-desc="true"
          :sort-by="sortBy" :page.sync="page" :items-per-page="itemsPerPage">
          <template v-slot:item="{ item }">
            <tr class="pointer">
              <td class="text-left">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      {{ item.createdAt | moment("from", "now") }}</span>
                  </template>
                  <span> {{ item.createdAt | moment("L LT") }}</span>
                </v-tooltip>
                <v-chip v-if="item.isCollected" small color="green" text-color="white" class="ml-2 font-weight-bold"
                  label>
                  <v-icon small left> mdi-credit-card-check </v-icon>
                  Collected
                </v-chip>
              </td>
              <td class="text-left">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                      {{ item.updatedAt | moment("from", "now") }}</span>
                  </template>
                  <span> {{ item.updatedAt | moment("L LT") }}</span>
                </v-tooltip>
              </td>
              <td class="text-left" v-html="$options.filters.highlight(
                item.Donor ? item.Donor.name : item.Donor,
                search.toLowerCase()
              )
                ">
                <span v-if="item.Donor">{{ item.Donor.name }}</span>
              </td>



              <td class="text-left" v-html="$options.filters.highlight(
                item.Donor ? item.Donor.phoneNumber : item.Donor,
                search.toLowerCase()
              )
                ">
                <span v-if="item.Donor">{{ item.Donor.phoneNumber }}</span>
              </td>

              <td class="text-right">
                <span v-if="item.Donor">{{ item.Donor.balance | currency }}</span>
              </td>

              <td class="text-left" v-html="$options.filters.highlight(item.link, search.toLowerCase())
                ">
                {{ item.link }}
              </td>
              <td class="text-left" v-html="$options.filters.highlight(item.message, search.toLowerCase())
                ">
                {{ item.message }}
              </td>
              <td>
                <v-chip v-if="item.messageCount !== 0" small color="red" text-color="white"
                  class="ml-2 font-weight-bold" label>
                  {{ item.messageCount }}
                </v-chip>
              </td>

              <td class="justify-end align-center text-right">
                <v-menu bottom left offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon>
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </template>
                  <v-list class="menu-button">
                    <v-list-item @click="viewProfile(item)">
                      <v-list-item-title>Open Profile</v-list-item-title>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item v-if="!item.isCollected && item.Donor.phoneNumber" @click="sendMessage(item)">
                      <v-list-item-title>Send Reminder</v-list-item-title>
                    </v-list-item>
                    <v-divider v-if="!item.isCollected && item.Donor.phoneNumber"></v-divider>
                    <v-list-item @click="edit(item)">
                      <v-list-item-title>Edit</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="deleteObj(item)">
                      <v-list-item-title>Delete</v-list-item-title>
                    </v-list-item>

                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="warning">Your search for "{{ search }}" found no
            results.</v-alert>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import paymentService from "@/modules/Donors/PaymentInfoCollect/service.js";
import { mapGetters } from "vuex";

const Create = () => import("@/modules/Donors/PaymentInfoCollect/Create.vue");
const Edit = () => import("@/modules/Donors/PaymentInfoCollect/Edit.vue");

export default {
  props: ["DonorId", "showBackButton", "access", "donor"],
  name: "donor-paymentMethod",
  data() {
    return {
      createDialog: false,
      editDialog: false,
      selectedDonor: null,
      headers: [
        {
          text: "Created At",
          align: "left",
          value: "createdAt",
          sortable: true,
        },
        {
          text: "Updated At",
          align: "left",
          value: "updatedAt",
          sortable: true,
        },
      ],
      paymentReq: [],
      search: "",
      loading: true,
      page: 1,
      sortBy: "updatedAt",
      pageCount: 0,
      itemsPerPage: 10,
    };
  },
  created() {
    this.getList();
    document.title = "taleem - Payment Collocation ";
    this.headers.push(
      {
        text: "Name",
        align: "left",
        value: "Donor.name",
        sortable: true,
      },
      {
        text: "Phone Number",
        align: "left",
        value: "Donor.phoneNumber",
        sortable: true,
      },
      {
        text: "Balance",
        align: "right",
        value: "Donor.balance",
        sortable: true,
      },
      {
        text: "Link",
        align: "left",
        value: "link",
        sortable: true,
      },
      {
        text: "Message",
        align: "left",
        value: "message",
        sortable: true,
      },
      {
        text: "",
        value: "action",
        sortable: false,
      },
      {
        text: "",
        value: "action",
        sortable: false,
      }
    );
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  filters: {
    highlight(words, query) {
      if (query) {
        var check = new RegExp(query.toLowerCase(), "ig");
        if (words) {
          return words.toString().replace(check, function (matchedText) {
            return '<span class="highlight">' + matchedText + "</span>";
          });
        } else {
          return words;
        }
      } else {
        return words;
      }
    },
  },
  watch: {
    search(val) {
      if (!val) {
        this.search = "";
      }
    },
  },
  components: {
    Create,
    Edit,
  },
  methods: {
    sendMessage(val) {
      // this.selectedDonor = val
      return paymentService.sendLink(val.id).then((response) => {
        console.log("response", response);
        // this.loading = false;
        // this.paymentReq = response.data;
        this.getList();
        return response;
      });
    },
    add() {
      console.log('a;lskdhjf;laksdjf;laskdjf')
      this.selectedDonor = this.DonorId;
      this.createDialog = !this.createDialog;
    },
    getList() {
      this.loading = true;
      this.editDialog = false;
      this.createDialog = false;
      return paymentService
        .getAll({ DonorId: this.DonorId })
        .then((response) => {
          console.log("response", response);
          this.loading = false;
          this.paymentReq = response.data;
          return response;
        });
    },
    edit(obj) {
      console.log("oldVendor selectedDonor", obj);
      this.selectedDonor = obj;
      this.editDialog = !this.editDialog;
    },
    viewProfile(obj) {
      console.log("oldVendor selectedDonor", obj);
      const routeData = this.$router.resolve({ path: `/donors/${obj.DonorId}/profile` });
      window.open(routeData.href, '_blank');
      // this.$router.push({ path: `/donors/${obj.DonorId}/profile` });
      // this.selectedDonor = obj;
      // this.editDialog = !this.editDialog;
    },
    deleteObj(obj) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          paymentService.delete(obj.id).then((response) => {
            if (response.data) {
              this.$swal("Deleted!", "row has been deleted.", "success");
              this.getList();
            }
          });
        }
      });
    },
  },
};
</script>
